import React, { createContext, useState } from 'react';
import { BASIC_INITIAL_STATE } from '@usas/ui-web/utils/HttpHelper';

export const NationalTeamGroupOfficialRosterStateContext = createContext();

export const INITIAL_STATE = {
  ...BASIC_INITIAL_STATE,
  items: [],
  areItemsLoaded: false,
  orgUnitId: '',
  omeMeetId: ''
};

const NationalTeamGroupOfficialRosterContextProvider = ({ children }) => {
  const stateHook = useState(INITIAL_STATE);

  return (
    <NationalTeamGroupOfficialRosterStateContext.Provider value={stateHook}>
      {children}
    </NationalTeamGroupOfficialRosterStateContext.Provider>
  );
};

export default NationalTeamGroupOfficialRosterContextProvider;